import React from 'react'
import "../Exotic Furnitures/Exoticfurnitures.css"
import one from "./exotic 37.jpg"
import two from "./exo 2.jpg"
import three from "./exo 3.jpg"
import four from "./exo 4.jpg"
import five from "./exo 5.jpg"
import six from "./exo 6.jpg"
import seven from "./exo 7.jpg"
import eight from "./exotic 10.jpg"
import nine from "./exotic 11.jpg"
import ten from "./exotic 12.jpg"
import eleven from "./exotic 13.jpg"
import twelve from "./exotic 14.jpg"
import thirt from "./exotic 15.jpg" 




const Exoticfurnitures = () => {
  return (
    <div>
      <div className='hello'>
      <div className='painti'>
        <img src={one} alt='knacker 104'/>
        <img src={thirt} alt='knacker 104'/>      
        <img src={eleven} alt='knacker 104'/>
      </div>
      <div className='painti'>
        <img src={six} alt='knacker 104'/>
        <img src={three} alt='knacker 104'/>
        <img src={four} alt='knacker 104'/>
      </div>
      <div className='painti'>
        <img src={nine} alt='knacker 104'/>
        <img src={seven} alt='knacker 104'/>
        <img src={twelve} alt='knacker 104'/>
        </div>
      <div className='painti'>
      <img src={ten} alt='knacker 104'/>
      <img src={eight} alt='knacker 104'/>
      <img src={five} alt='knacker 104'/>
      </div>
       <div className='painti'>
        <img src={two} alt='jwdb'/>
        </div>    
    </div> 
    </div>
  )
}

export default Exoticfurnitures
